export default __webpack_public_path__ + "static/media/rowing-blazers-alt.51945e6d.png";